import { render, staticRenderFns } from "./PageIntegrations.vue?vue&type=template&id=5926eec0&"
import script from "./PageIntegrations.vue?vue&type=script&lang=ts&"
export * from "./PageIntegrations.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports